import { Login, LoginCompleted, LoginFailed } from './auth-login.action';
import { LoginUuid, LoginUuidCompleted, LoginUuidFailed, CheckLoginUuid } from './auth-login-uuid.action';
import { Logout, LogoutCompleted, LogoutFailed } from './auth-logout.action';
import {
  PasswordResetTokenInvalid,
  PasswordResetTokenValid,
  PasswordResetTokenValidate,
} from './auth-password-reset-token-validate.action';
import { PasswordReset, PasswordResetFailed, PasswordResetSent } from './auth-password-reset.action';
import { PasswordUpdate, PasswordUpdateCompleted, PasswordUpdateFailed } from './auth-password-update.action';
import { LoadToken, LoadTokenCompleted, LoadTokenFailed } from './auth-token.action';

export { AuthActionType } from './auth-action-type.enum';

export { Login, LoginCompleted, LoginFailed } from './auth-login.action';
export { LoginUuid, LoginUuidCompleted, LoginUuidFailed, CheckLoginUuid } from './auth-login-uuid.action';
export { Logout, LogoutCompleted, LogoutFailed } from './auth-logout.action';
export {
  PasswordResetTokenInvalid,
  PasswordResetTokenValid,
  PasswordResetTokenValidate,
} from './auth-password-reset-token-validate.action';
export { PasswordReset, PasswordResetFailed, PasswordResetSent } from './auth-password-reset.action';
export { PasswordUpdate, PasswordUpdateCompleted, PasswordUpdateFailed } from './auth-password-update.action';
export { LoadToken, LoadTokenCompleted, LoadTokenFailed } from './auth-token.action';

export type AuthActions =

  LoadToken |
  LoadTokenCompleted |
  LoadTokenFailed |

  Login |
  LoginCompleted |
  LoginFailed |

  LoginUuid |
  LoginUuidCompleted |
  LoginUuidFailed |
  CheckLoginUuid |

  Logout |
  LogoutCompleted |
  LogoutFailed |

  PasswordReset |
  PasswordResetSent |
  PasswordResetFailed |
  PasswordResetTokenValidate |
  PasswordResetTokenValid |
  PasswordResetTokenInvalid |
  PasswordUpdate |
  PasswordUpdateCompleted |
  PasswordUpdateFailed;
